import { Box, Stack, Typography } from '@mui/material'
import { useCallback, useMemo, useState } from 'react'
import { CONVERSION_EVENTS_KEYS } from 'constants/index'
import useGetEvents from 'queries/use-get-events-list'
import CustomDataGrid from './DataGrid'
import SearchField from './SearchField'
import { Skeletons } from 'components/Skeletons'

export default function ManagementConversionEvents() {
  const [inputValue, setInputValue] = useState([])
  const { data: eventsRequestData, isLoading } = useGetEvents()

  const handleInputChange = useCallback((event, newValue) => {
    setInputValue(newValue)
  }, [])

  const { conversionList, eventList } = useMemo(() => {
    if (isLoading) return { conversionList: [], eventList: [] }

    let conversion = []
    let event = []

    if(inputValue.length){
      inputValue.forEach((value) =>{
        const itemFiltered = eventsRequestData.filter((item) => item.name === value.name && item.type.toLowerCase() === 'c')
        if(itemFiltered.length){
          conversion.push(itemFiltered[0])
        }
      })

      inputValue.forEach((value) =>{
        const itemFiltered = eventsRequestData.filter((item) => item.name === value.name && item.type.toLowerCase() === 'e')
        if(itemFiltered.length){
          event.push(itemFiltered[0])
        }
      })
    } else {
      conversion = eventsRequestData.filter((item) => item.type.toLowerCase() === 'c')
      event = eventsRequestData.filter((item) => item.type.toLowerCase() === 'e')
    }
    return { conversionList: conversion, eventList: event }
  }, [eventsRequestData, isLoading, inputValue])

  const conversionContentList = useMemo(() => {
    if(inputValue.length && conversionList?.length || !inputValue.length && conversionList?.length) {
      return <CustomDataGrid keyword={CONVERSION_EVENTS_KEYS.conversion} data={conversionList} />
    }
    else null
  }, [conversionList, inputValue])

  const eventContentList = useMemo(() => {
    if(inputValue.length && eventList?.length || !inputValue.length && eventList?.length) {
      return <CustomDataGrid keyword={CONVERSION_EVENTS_KEYS.event} data={eventList} />
    }
    else null
  }, [eventList, inputValue])

  if(isLoading) return <Skeletons.ManagementEvents />

  return (
    <Stack>
      <Typography
        sx={{
          fontSize: '2rem',
          fontWeight: '900',
          lineHeight: 1.5,
        }}
      >
        Gerenciar eventos e conversões
      </Typography>
      <Typography variant="body2" sx={{ fontSize: '1rem', mb: '2rem' }}>
        Habilite os eventos e conversões que deseja rastrear nas conversas com seus consumidores nos canais Hi Platform. Após habilitá-los, configure os acionamentos no seu fluxo de Hi Bot.
      </Typography>
      <SearchField {...{ loading: isLoading, options: eventsRequestData, handleInputChange }} />

      <Box display="flex" flexDirection="column" gap="2rem" mt="2rem" paddingBottom="1rem">
        {conversionContentList}
        {eventContentList}
      </Box>
    </Stack>
  )
}
